import React, { createContext } from 'react';

import { TEntities } from '../helpers/entities';

type TAlerts = {
  crudStatus: 'clone' | 'create' | 'update' | 'delete';
  systemStatus: 'success' | 'info' | 'warning' | 'error';
};

type TDelete = {
  id: string;
  name: string;
  type?: string | undefined;
  deviceTypeId?: string;
};

export type TContext = {
  handleDelete: (id: string, name: string, type?: string, deviceTypeId?: string) => void;
  selectedItem: TDelete;
  setSelectedItem: React.Dispatch<React.SetStateAction<TDelete>>;
  smartBarActive: boolean;
  setSmartBarActive: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  toggle: boolean;
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
  changeToggle: () => void;
  systemAlert: (status: TAlerts['systemStatus'] | 'error', text: string) => void;
  crudAlert: (
    status: TAlerts['crudStatus'],
    entity: TEntities['entitySingular'],
    gender: 'default' | 'f' | 'm',
    name?: string
  ) => void;
};

export const AppContext: React.Context<TContext | null> = createContext<TContext | null>(null);
